module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('span', {
    staticClass: "md-title"
  }, [_vm._v("INSTALAÇÕES")]), _vm._v(" "), _c('span', {
    staticClass: "md-caption"
  }, [_vm._v("Siga o passo a passo abaixo com atenção. ")]), _vm._v(" "), _c('md-stepper', {
    attrs: {
      "md-vertical": "",
      "md-elevation": "0"
    },
    on: {
      "completed": function($event) {
        return _vm.finishArea()
      }
    }
  }, [_c('md-step', {
    attrs: {
      "md-continue": _vm.certificationProcess.status > 0,
      "md-active": _vm.certificationProcess.status <= 0,
      "md-label": "Carregamento da Planta do BLH",
      "md-button-back": "Voltar",
      "md-button-continue": "Próximo: INSTALAÇÕES"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('p', [_vm._v("Selecione a planta baixa, fundo branco e linhas pretas.")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-accent md-raised",
    on: {
      "click": function($event) {
        return _vm.openBlueprintDialog()
      }
    }
  }, [_vm._v("DEFINIR PLANTA BLH")])], 1)], 1), _vm._v(" "), _c('md-step', {
    attrs: {
      "md-continue": _vm.certificationProcess.status > 1,
      "md-active": _vm.certificationProcess.status == 1,
      "md-label": "Definição das Instalações",
      "md-button-back": "Voltar",
      "md-button-continue": "Próximo: EQUIPAMENTOS"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('p', [_vm._v("Descreva as instalações do banco de leite humano")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-accent md-raised",
    on: {
      "click": function($event) {
        return _vm.openAreas()
      }
    }
  }, [_vm._v("INSTALAÇÕES DO BLH")])], 1)], 1), _vm._v(" "), _c('md-step', {
    attrs: {
      "md-continue": _vm.certificationProcess.status > 2,
      "md-active": _vm.certificationProcess.status >= 2,
      "md-label": "Listagem de Equipamentos",
      "md-button-back": "Voltar",
      "md-button-continue": "Próximo: Fotos"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('md-button', {
    staticClass: "md-accent md-raised",
    on: {
      "click": function($event) {
        return _vm.openStructure()
      }
    }
  }, [_vm._v("EQUIPAMENTOS DO BLH")])], 1)], 1)], 1), _vm._v(" "), _c('blueprint-dialog', {
    ref: "startdialog",
    attrs: {
      "title": "Planta do BLH",
      "imageId": _vm.certificationProcess.blueprint,
      "blueprintUrl": _vm.certificationProcess.blueprintUrl
    },
    on: {
      "select": _vm.blueprintSelected
    }
  }), _vm._v(" "), _c('md-snackbar', {
    ref: "snackbar_sync",
    attrs: {
      "md-position": 'bottom center',
      "md-duration": Infinity
    }
  }, [(_vm.isSyncingArea && !_vm.syncSuccessfull) ? _c('span', [_vm._v("Salvando...")]) : _vm._e(), _vm._v(" "), (_vm.syncSuccessfull) ? _c('span', [(_vm.hasError !== '') ? _c('span', [_vm._v("\n        " + _vm._s(_vm.hasError) + "\n      ")]) : _c('span', [_vm._v("\n        ENVIADO COM SUCESSO!\n      ")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-accent",
    attrs: {
      "md-theme": "light-blue"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.snackbar_sync.close()
      }
    }
  }, [_vm._v("Fechar")])], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-503783d5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AreaDefinitions.vue
// module id = 834
// module chunks = 1